<template>
	<div class="panel wrap_panel shadow-0 border-0" id="panel_exchange_user_list">
		<div class="panel-hdr text-danger">
			<h2>
				<span class="fw-300"><i>Користувачi</i></span>
			</h2>
		</div>

		<div class="panel-container">
			<div class="panel-content">
				<div class="row-fluid">
					<div class="user_list_exchange">
						<div v-if="users.length === 0">
							<div class="empty_block">
								Користувачiв не знайдено
							</div>
						</div>
						<div class="exist_user" v-else>
							<b-overlay :show="is_load">
								<f_users_table :user_id="parseInt(this.user.id)" :users="users"></f_users_table>
							</b-overlay>
						</div>
					</div>
				</div>
			</div>
		</div>


		<f_users_edit :user_id="parseInt(this.user.id)"></f_users_edit>
		<div class="add_block">
			<div class="buttons">
				<div class="next_step">
					<button type="button" class="btn btn-lg btn-outline-primary waves-effect waves-themed add_exchange_user" v-on:click="edit_user(null)">
						<span class="fal fa-check mr-1"></span>
						Додати
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import {mapGetters} from "vuex";
import F_users_table from "./users/f_users_table";
import F_users_edit from "./users/f_users_edit";
export default {
	name: "f_users",
	components: {F_users_edit, F_users_table},
	created() {
		this.load_user_list();
		EventBus.$on('reload_exchange_users',this.load_user_list);
	},
	beforeDestroy() {
		EventBus.$off('reload_exchange_users',this.load_user_list);
	},

	data () {
		return {
			users : [],
			is_load : false,
		}
	},

	methods : {
		async load_user_list() {
			this.is_load = true;
			await api.get('/user/' + this.user.id + "/file_exchange/users").then(({data}) => {
				this.is_load = false;
				if(data.status === "operation_success") {
					this.users = data.data;
				}
			}).catch(err => {
				this.is_load = false;
				console.log(err);
			});
		},

		remove_user(id) {

		},

		edit_user(user) {
			EventBus.$emit('edit_exchange_user',user);
		},
	},

	computed : {
		...mapGetters({
			'user': "user/getUser",
		}),
	}
}
</script>

<style scoped>

</style>
